import { useEffect, useState } from "react";
import { useAppContext } from "utils/context";
import { Button, Skeleton } from "antd";

import { useTranslation } from "react-i18next";
import { getPmaDownloadContract } from "containers/pmaOnboarding/services/service";

import PdfViewer from "./pdfView";

const ContractView = ({ currentContract, onbUuid, onCloseContract }) => {
  const { instance } = useAppContext();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const handleGetPmaDownloadContract = async () => {
    setLoading(true);
    const res = await getPmaDownloadContract(instance, {
      pmaUuid: onbUuid,
      contractKey: currentContract?.key,
    });

    if (res) setData(res);
    setLoading(false);
  };

  useEffect(() => {
    handleGetPmaDownloadContract();
  }, []);

  return (
    <>
      <div className="p-5">
        {loading ? (
          <Skeleton.Input active block className="!min-w-0 !w-full !h-8" />
        ) : (
          !["", null, undefined].includes(data) && (
            <div className="bg-white rounded-lg shadow-lg p-4 relative overflow-hidden">
              <PdfViewer fileName={currentContract?.name} pdf={data} />
            </div>
          )
        )}
      </div>

      <div className="p-5 z-10 fixed bottom-0 border-t bg-white border-gray--7 max-w-2xl w-full">
        <Button
          className={`default-button-large min-h-[46px] justify-center items-center`}
          block
          onClick={onCloseContract}
        >
          {t("close")}
        </Button>
      </div>
    </>
  );
};

export default ContractView;
